import { Agent as HttpAgent, AgentOptions } from 'http';
import { Agent as HttpsAgent } from 'https';

import { ClientConfiguration } from 'aws-sdk/clients/dynamodb';

import { isInCloudEnvironment, IS_PRODUCTION_LAMBDA } from '../../util/environment';

type EndpointClientConfiguration = ClientConfiguration & {
  endpoint?: string;
};

function awsClientConfiguration(config: EndpointClientConfiguration): ClientConfiguration {
  const { AWS_REGION, AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY } = process.env;

  let region = AWS_REGION;
  let accessKeyId = undefined;
  let secretAccessKey = undefined;

  if (!IS_PRODUCTION_LAMBDA) {
    region = region || 'us-east-1';
    accessKeyId = AWS_ACCESS_KEY_ID || 'accessKeyId';
    secretAccessKey = AWS_SECRET_ACCESS_KEY || 'secretAccessKey';
  }

  // keepAlive improves performance
  const agentOptions: AgentOptions = {
    keepAlive: true,
    maxSockets: 50,
  };

  const dynamoHttpAgent = isInCloudEnvironment(config.endpoint)
    ? new HttpsAgent({ ...agentOptions, rejectUnauthorized: true })
    : new HttpAgent(agentOptions);

  return {
    region,
    accessKeyId,
    secretAccessKey,
    httpOptions: {
      agent: dynamoHttpAgent,
    },
    ...config,
  };
}

export function dynamoClientConfiguration(config: ClientConfiguration = {}): ClientConfiguration {
  const { AWS_DYNAMODB_ENDPOINT } = process.env;
  let dynamoEndpoint = config.endpoint || AWS_DYNAMODB_ENDPOINT;
  if (!IS_PRODUCTION_LAMBDA && !dynamoEndpoint) {
    dynamoEndpoint = 'http://localhost:8000';
  }
  return awsClientConfiguration({ ...config, endpoint: dynamoEndpoint });
}

export function sqsClientConfiguration(config: ClientConfiguration = {}): ClientConfiguration {
  const { AWS_SQS_ENDPOINT } = process.env;
  let sqsEndpoint = config.endpoint || AWS_SQS_ENDPOINT;
  if (!IS_PRODUCTION_LAMBDA && !sqsEndpoint) {
    sqsEndpoint = 'http://localhost:9324';
  }
  return awsClientConfiguration({ ...config, endpoint: sqsEndpoint });
}
